module.exports = __webpack_public_path__ + "media/images/site/fundamental2_menino-cd2c5c61860fa897f266dac68a8ac7d8.jpg";